var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdd2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.092v-6h2v6h6v2h-6v6h-2v-6H5v-2h6z",
    fill: "#A7A9AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdd2);
export default __webpack_public_path__ + "static/media/ic-add2.db2fad49dd0873021a7631937cce0f22.svg";
export { ForwardRef as ReactComponent };